import { PageRenderer } from "./page-renderer"; // this is for back compat as the original PageLayout was poorly named, that has now been renamed PageRenderer as it is really just a mechanical component that checks for page layouts and slice layouts

export var PageLayout = PageRenderer;